import { toneNumbersPinyinText } from "@-/dev.improve.haniverse.database.schemas._lib.types.pinyin";
import {
  bool,
  contentTable,
  index,
  integer,
  text,
} from "@-/dev.improve.haniverse.lib.database.table";

export const appGraphemePronunciationCardTable = contentTable(
  "app_grapheme_pronunciation_card",
  {
    /**
     * Display copy, rewritten by content edits. NEVER a join key: `actor.user_grapheme_pronunciation_card`
     * joins on `(grapheme, pinyin)`, the reading's identity.
     */
    gloss: text("gloss").notNull(),

    grapheme: text("grapheme").notNull(),

    /**
     * The reading's HSK 2026 level (`7-9` → 7); null when the syllabus does not list it. A
     * simplified-script lesson introduces every reading at or below its own curriculum grade.
     */
    hsk2026Level: integer("hsk_2026_level"),

    /**
     * The character's main reading, taught at the lowest HSK/TBCL level. Introducing a character
     * enrolls this reading plus every other reading at or below the lesson's curriculum grade; a
     * higher reading is enrolled when a word using it is.
     */
    isMain: bool("is_main").notNull(),

    phrase: text("phrase"),
    // Canonical tone numbers, like every other pinyin column. The grapheme files spell a neutral
    // reading bare (`me`), and a plain text column kept it that way, so a neutral-tone card's
    // `DrillType` pinyin (`me`) never matched its reading key (`me0`) elsewhere.
    pinyin: toneNumbersPinyinText("pinyin").notNull(),
    prompt: text("prompt"),
    /** The reading's TBCL level, the traditional-script counterpart of `hsk2026Level`. */
    tbclLevel: integer("tbcl_level"),
    /**
     * The words this reading appears in (grapheme file `pinyin.<reading>.usage`). `exhaustive`
     * marks a reading that only occurs in `words` (会 kuài: 会计), which the pronunciation review
     * shows as "only in 会计" under the gloss. Null when the file lists no words.
     */
    usage: text("usage", { mode: "json" }).$type<{ exhaustive: boolean; words: string[] }>(),
  },
  // A grapheme has multiple pronunciation rows, so this is non-unique (unlike
  // `app_grapheme_meaning_card.grapheme`, which is `.unique()` + indexed).
  // Without it the pinyin lookup and the `with: { pronunciationCards }` join
  // full-scan the table on every read.
  (table) => [index("app_grapheme_pronunciation_card_grapheme_idx").on(table.grapheme)],
);

export type AppGraphemePronunciationCard = typeof appGraphemePronunciationCardTable.$inferSelect;
